module.exports = __webpack_public_path__ + "media/hassan Giff.7548eebe.mp4";